export default "__VITE_ASSET__DEfb4bjF__"